// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAzX15fs7cUaBWjWsxQKnlUJ4qAZ4ocUdc',
    authDomain: 'josh-matsushima.firebaseapp.com',
    databaseURL: 'https://josh-matsushima.firebaseio.com',
    projectId: 'josh-matsushima',
    storageBucket: 'josh-matsushima.appspot.com',
    messagingSenderId: '43509067268',
    appId: '1:43509067268:web:a266ca4d2f694fe7d74f51',
    measurementId: 'G-MKQMTX2S4N',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
